var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { uniqueId } from 'lodash-es';
import styles from './sds-radio.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Control represents a radio button
 *
 * This component provides the following features:
 * - Three states: checked, unchecked, and disabled
 * - Keyboard navigation support (Space key for selection)
 * - Error state handling
 * - Accessibility features (ARIA attributes, screen reader support)
 * - Custom styling with focus indicators
 *
 * @tag sds-radio
 *
 * @fires sds.radio.changed - Fired when the radio button state changes.
 *   Event detail contains the checked state: `{checked: boolean}`
 * @fires change - Native change event, fired when the radio button state changes.
 *   Event detail contains the checked state: `{checked: boolean}`
 * @fires focus - Native focus event, fired when the radio button receives focus
 * @fires blur - Native blur event, fired when the radio button loses focus
 * @fires click - Native click event, fired when the radio button is clicked
 */
let SdsRadio = (() => {
    var _SdsRadio_value_accessor_storage, _SdsRadio_name_accessor_storage, _SdsRadio_checked_accessor_storage, _SdsRadio_disabled_accessor_storage, _SdsRadio_invalid_accessor_storage, _SdsRadio_label_accessor_storage, _SdsRadio_ariaLabel_accessor_storage, _SdsRadio_description_accessor_storage, _SdsRadio__radio_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-radio')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _checked_decorators;
    let _checked_initializers = [];
    let _checked_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _ariaLabel_decorators;
    let _ariaLabel_initializers = [];
    let _ariaLabel_extraInitializers = [];
    let _description_decorators;
    let _description_initializers = [];
    let _description_extraInitializers = [];
    let __radio_decorators;
    let __radio_initializers = [];
    let __radio_extraInitializers = [];
    var SdsRadio = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsRadio_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, void 0));
            _SdsRadio_name_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _name_initializers, void 0)));
            _SdsRadio_checked_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _checked_initializers, false)));
            _SdsRadio_disabled_accessor_storage.set(this, (__runInitializers(this, _checked_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsRadio_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsRadio_label_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _label_initializers, void 0)));
            _SdsRadio_ariaLabel_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _ariaLabel_initializers, void 0)));
            _SdsRadio_description_accessor_storage.set(this, (__runInitializers(this, _ariaLabel_extraInitializers), __runInitializers(this, _description_initializers, '')));
            _SdsRadio__radio_accessor_storage.set(this, (__runInitializers(this, _description_extraInitializers), __runInitializers(this, __radio_initializers, void 0)));
            /** Unique ID for the radio input */
            this._unique = (__runInitializers(this, __radio_extraInitializers), uniqueId('sds-radio'));
            /** Whether the radio is currently focused */
            this._isFocused = false;
            /** Whether the radio was clicked (vs. focused via keyboard) */
            this._isClicked = false;
        }
        /**
         * The value associated with this radio button.
         * This value is used when the radio button is part of a group.
         *
         * @attr
         */
        get value() { return __classPrivateFieldGet(this, _SdsRadio_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsRadio_value_accessor_storage, value, "f"); }
        /**
         * The name of the radio button group this radio belongs to.
         * Radio buttons with the same name form a group where only one can be selected.
         *
         * @attr
         */
        get name() { return __classPrivateFieldGet(this, _SdsRadio_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsRadio_name_accessor_storage, value, "f"); }
        /**
         * Whether the radio button is checked.
         * Only one radio button in a group can be checked at a time.
         *
         * @attr
         * @default false
         */
        get checked() { return __classPrivateFieldGet(this, _SdsRadio_checked_accessor_storage, "f"); }
        set checked(value) { __classPrivateFieldSet(this, _SdsRadio_checked_accessor_storage, value, "f"); }
        /**
         * Whether the radio button is disabled and cannot be interacted with.
         *
         * @attr
         * @default false
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsRadio_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsRadio_disabled_accessor_storage, value, "f"); }
        /**
         * Whether the radio button is in an invalid state.
         * When true, error styling will be applied.
         *
         * @attr
         * @default false
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsRadio_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsRadio_invalid_accessor_storage, value, "f"); }
        /**
         * The label text displayed next to the radio button.
         *
         * @attr
         */
        get label() { return __classPrivateFieldGet(this, _SdsRadio_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsRadio_label_accessor_storage, value, "f"); }
        /**
         * The ARIA label for the radio button's internal label element.
         * @internal This property is used internally by the radio group component.
         */
        get ariaLabel() { return __classPrivateFieldGet(this, _SdsRadio_ariaLabel_accessor_storage, "f"); }
        set ariaLabel(value) { __classPrivateFieldSet(this, _SdsRadio_ariaLabel_accessor_storage, value, "f"); }
        /**
         * Additional descriptive text displayed below the label.
         *
         * @attr
         * @default ''
         */
        get description() { return __classPrivateFieldGet(this, _SdsRadio_description_accessor_storage, "f"); }
        set description(value) { __classPrivateFieldSet(this, _SdsRadio_description_accessor_storage, value, "f"); }
        /** Reference to the native radio input element */
        get _radio() { return __classPrivateFieldGet(this, _SdsRadio__radio_accessor_storage, "f"); }
        set _radio(value) { __classPrivateFieldSet(this, _SdsRadio__radio_accessor_storage, value, "f"); }
        /**
         * Sets the focused state of the radio button
         * @param focused - Whether the radio should be focused
         */
        setFocused(focused) {
            this._isFocused = focused;
            this.requestUpdate();
        }
        /**
         * Programmatically focuses the radio button.
         * This method can be called from outside the component to set focus.
         */
        focus() {
            this._radio.focus();
            this._isFocused = true;
            this.requestUpdate();
        }
        /**
         * Programmatically clicks the radio button.
         * This method can be called from outside the component to select the radio.
         */
        click() {
            this._radio.click();
        }
        /**
         * Handles the focus event on the radio input.
         * Sets the focused state and dispatches a focus event.
         */
        handleFocus() {
            if (!this._isClicked) {
                this._isFocused = true;
            }
            this.requestUpdate();
            this.dispatchEvent(new CustomEvent(SdsRadio.FOCUS_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Handles the blur event on the radio input.
         * Clears the focused and clicked states and dispatches a blur event.
         */
        handleBlur() {
            this._isFocused = false;
            this._isClicked = false;
            this.requestUpdate();
            this.dispatchEvent(new CustomEvent(SdsRadio.BLUR_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Handles the click event on the radio label.
         * Prevents focus styling when the radio is clicked with a mouse.
         */
        handleClick() {
            if (this._isClicked) {
                this._isFocused = false;
            }
            this._isClicked = true;
            this.dispatchEvent(new CustomEvent(SdsRadio.CLICK_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Handles keyboard events on the radio.
         * Manages focus styling based on keyboard interaction.
         *
         * @param e - The keyboard event
         */
        handleKeyDown(e) {
            // Ignore modifier keys (Shift, Ctrl, Alt, Meta)
            if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt' || e.key === 'Meta') {
                return;
            }
            // Handle arrow keys for navigation
            if (e.key === 'ArrowLeft' ||
                e.key === 'ArrowRight' ||
                e.key === 'ArrowUp' ||
                e.key === 'ArrowDown') {
                e.preventDefault();
                this._isFocused = true;
                this.requestUpdate();
                const radioGroup = this.closest('sds-radio-group');
                if (radioGroup) {
                    radioGroup.handleArrowKeyNavigation(e.key, this);
                }
                return;
            }
            // Handle space key for selection
            if (e.key === ' ' || e.key === 'Space' || e.key === 'Spacebar') {
                e.preventDefault();
                this._isFocused = true;
                this.requestUpdate();
                this.click();
                return;
            }
        }
        /**
         * Handles the change event on the radio input.
         * Updates the component state and dispatches change events.
         */
        handleChange() {
            this.checked = this._radio.checked;
            this.dispatchEvent(new CustomEvent(SdsRadio.CHANGED_EVENT, {
                detail: {
                    checked: this.checked,
                },
                bubbles: false,
                composed: false,
            }));
            this.dispatchEvent(new CustomEvent(SdsRadio.NATIVE_CHANGE_EVENT, {
                detail: {
                    checked: this.checked,
                },
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Updates the native radio input when the checked property changes.
         */
        updated() {
            this._radio.checked = this.checked;
        }
        /**
         * Renders the radio component.
         *
         * @returns The rendered HTML template
         */
        render() {
            return html `
            <label
                class="${this.getClasses()}"
                for="${this._unique}"
                @keydown="${(e) => this.handleKeyDown(e)}"
                @click="${() => this.handleClick()}"
            >
                <input
                    class="sds-radio__input"
                    type="radio"
                    id="${this._unique}"
                    role="radio"
                    aria-checked="${this.checked}"
                    aria-disabled="${this.disabled}"
                    aria-invalid="${this.invalid}"
                    aria-label="${this.ariaLabel}"
                    ?checked="${this.checked}"
                    ?disabled="${this.disabled}"
                    value="${this.value}"
                    name="${this.name}"
                    @change="${() => this.handleChange()}"
                    @focus="${() => this.handleFocus()}"
                    @blur="${() => this.handleBlur()}"
                />
                ${this.renderContent()}
            </label>
        `;
        }
        renderContent() {
            if (!this.label && !this.description) {
                return html ``;
            }
            return html `
            <div class="sds-radio__content" aria-hidden="true">
                ${this.label ? html `<div class="sds-radio__label">${this.label}</div>` : html ``}
                ${this.description
                ? html `<div class="sds-radio__description" id="${this._unique}-description">
                          ${this.description}
                      </div>`
                : html ``}
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * Gets the CSS classes to apply to the radio based on its state.
         *
         * @returns An object mapping class names to boolean values
         */
        getClasses() {
            return classMap({
                'sds-radio': true,
                'sds-radio--checked': this.checked,
                'sds-radio--disabled': this.disabled,
                'sds-radio--invalid': this.invalid,
                'sds-radio--focused': this._isFocused,
            });
        }
    };
    _SdsRadio_value_accessor_storage = new WeakMap();
    _SdsRadio_name_accessor_storage = new WeakMap();
    _SdsRadio_checked_accessor_storage = new WeakMap();
    _SdsRadio_disabled_accessor_storage = new WeakMap();
    _SdsRadio_invalid_accessor_storage = new WeakMap();
    _SdsRadio_label_accessor_storage = new WeakMap();
    _SdsRadio_ariaLabel_accessor_storage = new WeakMap();
    _SdsRadio_description_accessor_storage = new WeakMap();
    _SdsRadio__radio_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsRadio");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _value_decorators = [property({ type: String })];
        _name_decorators = [property({ type: String })];
        _checked_decorators = [property({ type: Boolean, reflect: true })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _label_decorators = [property({ type: String })];
        _ariaLabel_decorators = [property({
                type: String,
                attribute: false, // Prevent attribute reflection to avoid duplication
            })];
        _description_decorators = [property({ type: String })];
        __radio_decorators = [query('input[type=radio]')];
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _checked_decorators, { kind: "accessor", name: "checked", static: false, private: false, access: { has: obj => "checked" in obj, get: obj => obj.checked, set: (obj, value) => { obj.checked = value; } }, metadata: _metadata }, _checked_initializers, _checked_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(_classThis, null, _ariaLabel_decorators, { kind: "accessor", name: "ariaLabel", static: false, private: false, access: { has: obj => "ariaLabel" in obj, get: obj => obj.ariaLabel, set: (obj, value) => { obj.ariaLabel = value; } }, metadata: _metadata }, _ariaLabel_initializers, _ariaLabel_extraInitializers);
        __esDecorate(_classThis, null, _description_decorators, { kind: "accessor", name: "description", static: false, private: false, access: { has: obj => "description" in obj, get: obj => obj.description, set: (obj, value) => { obj.description = value; } }, metadata: _metadata }, _description_initializers, _description_extraInitializers);
        __esDecorate(_classThis, null, __radio_decorators, { kind: "accessor", name: "_radio", static: false, private: false, access: { has: obj => "_radio" in obj, get: obj => obj._radio, set: (obj, value) => { obj._radio = value; } }, metadata: _metadata }, __radio_initializers, __radio_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsRadio = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    /** Event name for the custom change event */
    _classThis.CHANGED_EVENT = 'sds.radio.changed';
    /** Event name for the native change event */
    _classThis.NATIVE_CHANGE_EVENT = 'change';
    /** Event name for the native focus event */
    _classThis.FOCUS_EVENT = 'focus';
    /** Event name for the native blur event */
    _classThis.BLUR_EVENT = 'blur';
    /** Event name for the native click event */
    _classThis.CLICK_EVENT = 'click';
    /** Component styles */
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsRadio = _classThis;
})();
export { SdsRadio };
